import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MenuItemModel } from '../../common/models';
import { IconNames, StatusLabelColor } from '../../common/constants';
import { RouterFacade } from '../../store/state/router/router.facade';
import { ProjectorName } from '../../container-components/projection/projector.constant';
import { AuthFacade } from '../../store/state/auth';
import { from, Observable, of } from 'rxjs';
import { filter, map, switchMap, toArray } from 'rxjs/operators';

@Component({
  selector: 'ui-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hideBackBtn: boolean;
  @Input() backBtnPath: string;
  @Input() backBtnQueryParams: { [key: string]: unknown };
  @Input() labelText: string;
  @Input() labelColor: StatusLabelColor = StatusLabelColor.Red;
  @Input() preserveQueryParams = false;
  @Input() tooltipText: string;
  @Input() noIndents = false;

  @Input() set menuList(menu: MenuItemModel[]) {
    if (!menu) {
      return;
    }
    this.displayedMenuItems$ = this.filteredMenuByPermissions(menu);
  }

  projectorName = ProjectorName;
  displayedMenuItems$: Observable<MenuItemModel[]>;
  iconNameList = IconNames;

  constructor(public routerFacade: RouterFacade, private authFacade: AuthFacade) {}

  private filteredMenuByPermissions(allMenuItems: MenuItemModel[]): Observable<MenuItemModel[]> {
    return from(allMenuItems).pipe(
      switchMap((item: MenuItemModel) =>
        item.permission
          ? this.authFacade.hasPermission$(item.permission).pipe(map((hasPermission: boolean) => [item, hasPermission]))
          : of([item, true]),
      ),
      filter(([_item, hasPermission]: [_item: MenuItemModel, hasPermission: boolean]) => hasPermission),
      map(([item, _hasPermission]: [item: MenuItemModel, _hasPermission: boolean]) => item),
      toArray(),
    );
  }
}
